import { get, post, remove } from '../services/common/common.service';
import { priceBookEndPoint, commonEndPoints } from '../constants/endpoint';

// start pricesheet apis
export const fetchAccountingGroupsData = (payload) =>
  get(priceBookEndPoint.accountingGroup, payload);

export const fetchCountriesData = (payload) =>
  get(commonEndPoints.countries, payload);

export const fetchPriceTypesData = (payload) =>
  get(priceBookEndPoint.priceTypes, payload);

export const priceSheetSearchData = (payload) =>
  post(priceBookEndPoint.priceSheetSearch, payload);

export const countriesSearchData = (payload) =>
  post(commonEndPoints.countrySearch, payload);

export const accountingGroupSearchData = (payload) =>
  post(priceBookEndPoint.accountingGroupSearch, payload);

export const priceClassSearchData = (payload) =>
  post(priceBookEndPoint.priceClassSearch, payload);

export const priceSheetGetData = (payload) =>
  get(
    `${priceBookEndPoint.priceSheetGet}?PriceSheetId=${payload.priceSheetId}`,
    payload
  );

export const pricesGetData = (payload) =>
  get(
    `${priceBookEndPoint.pricesGet}?PriceSheetId=${payload.priceSheetId}&RecordCount=${payload.recordCount}&PageIndex=${payload.pageNumber}`,
    payload
  );

export const fetchPricesGetData = (payload) =>
  get(
    `${priceBookEndPoint.pricesGet}?PriceSheetId=${payload.priceSheetId}&RecordCount=${payload.recordCount}&PageIndex=${payload.pageNumber}&PriceClassName=${payload.priceClassName}`,
    payload
  );

export const priceSheetNotesData = (payload) =>
  get(
    `${priceBookEndPoint.priceSheetNotes}?PriceSheetId=${payload.priceSheetId}&PriceNoteType=${payload.priceSheetNoteType}`,
    payload
  );

export const priceSheetAuditTrailData = (payload) =>
  get(
    `${priceBookEndPoint.priceSheetAuditTrail}?PriceSheetId=${payload.priceSheetId}&PriceNoteType=${payload.priceSheetNoteType}`,
    payload
  );

export const fetchPriceClassServiceOfferings = (payload) =>
  post(priceBookEndPoint.priceClassServiceOfferings, payload);

export const priceSheetSaveData = (payload) =>
  post(priceBookEndPoint.priceSheetSave, payload);

export const fetchPriceSheetSearchCount = (payload) =>
  post(priceBookEndPoint.priceSheetSearchCount, payload);

export const copypriceSheetSaveData = (payload) =>
  post(priceBookEndPoint.copypriceSheetSave, payload);

// end pricesheet apis

export const fetchPriceClassData = (payload) =>
  get(
    `${priceBookEndPoint.priceClassGet}?pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}`
  );

//Bill Class apis
export const fetchBillClass = (payload) => {
  return get(
    `${priceBookEndPoint.billClass}?pageNumber=${payload.pageNumber}&pageSize=${payload.pageSize}`,
    payload
  );
};

export const searchBillClass = (payload) =>
  post(priceBookEndPoint.billClassSearch, payload);

export const removeBillClass = (payload) => {
  return remove(`${priceBookEndPoint.removeBillClass}/${payload}`);
};

export const addBillClass = (payload) => {
  return post(priceBookEndPoint.addBillClass, payload);
};
